import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject, BehaviorSubject, Observable} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {InactiveLicensesInformationService} from '../../../../domain/model/licenses-certifications/inactive/inactive-licenses-information.service';
import {InactiveLicensesInformation} from '../../../../domain/model/licenses-certifications/inactive/inactive-licenses-information.model';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {coerceBooleanProperty} from '../../../../common/value/coercion/boolean-coercion.util';

@Component({
    template: require('./inactive-licenses-information-screen.component.html')
})
export class InactiveLicensesInformationScreenComponent {

    constructor(readonly modelService: InactiveLicensesInformationService,
                readonly route: ActivatedRoute,
                countryService: CountryService) {
        countryService.getStatesForCountry('US').subscribe(states => this.states = states.map(s => ({
            value: s.code,
            display: s.name
        })));

        this.hasInactiveLicenses$ = this.hasInactiveLicensesChange$
            .filter(value => value || confirm('Changing this answer will cause inactive licenses data to be deleted?'))
            .publishReplay(1).refCount();

        this.hasInactiveLicenses$.subscribe(value => {
            if (!value) modelService.deleteCurrentUserModel().subscribe(() => this.stepScreenModel.goToNextScreenWithoutSaving());
        });
    }

    hasInactiveLicensesChange$ = new BehaviorSubject<boolean>(true);
    hasInactiveLicenses$: Observable<boolean>;

    changeHasInactiveLicensesAnswer(value: boolean, event) {
        event.preventDefault();
        setTimeout(() => this.hasInactiveLicensesChange$.next(coerceBooleanProperty(value)));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    states: Array<{value: any; display: string;}> = [];

    stepScreenModel = new StepScreenModel<InactiveLicensesInformation>({
        initialDataModel: new InactiveLicensesInformation(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: InactiveLicensesInformation) => {
            return this.modelService.updateCurrentUserModel(model);
        },
        _hasYesNoQuestion: () => this.modelService.doesCurrentUserModelExist().map(r => !r)
    });

    get model(): InactiveLicensesInformation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/inactive/inactive-licenses-information-screen.component.ts